import * as Yup from 'yup';

// form validation rules
export const ProductStatSchema = Yup.object().shape({
  last_1: Yup.number().required(),
  last_7: Yup.number().required(),
  last_14: Yup.number().required(),
  last_30: Yup.number().required(),
  last_60: Yup.number().required(),
  last_90: Yup.number().required(),
  last_120: Yup.number().required(),
  last_150: Yup.number().required(),
  last_180: Yup.number().required(),
  last_365: Yup.number().required(),

  last_year_next_30: Yup.number().required(),
  last_year_next_60: Yup.number().required(),
  last_year_next_90: Yup.number().required(),
  last_year_next_120: Yup.number().required(),
  last_year_next_150: Yup.number().required(),
  last_year_next_180: Yup.number().required(),

  days_on_hand: Yup.number().required(),

  avg_sales_interval: Yup.number().required(),
  sales_interval_stddev: Yup.number().required(),
  sale_day_count: Yup.number().required(),
});
